//#region src/recentSearches/selectRecentStaySearches.ts
var e = 3, t = "unit", n = (e) => e.filter((e) => e.kind === t).slice(0, 3);
//#endregion
export { e as RECENT_STAY_SEARCHES_LIMIT, n as selectRecentStaySearches };
